import { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger, cn } from "../../ui";
export const Accordion = ({ textColor, bgColor, title, content, value, }) => {
    const style = {
        ["--text-color"]: textColor,
        ["--bg-color"]: bgColor,
    };
    return (<div style={style} className={cn("px-4 text-[var(--text-color)]", bgColor ? "bg-[var(--bg-color)]" : "bg-gray-bg")}>
            <AccordionRoot type="single" collapsible>
                <AccordionItem value={value}>
                    <AccordionTrigger className="flex cursor-pointer items-center justify-between border-b py-4 transition-all duration-300 data-[state=open]:border-b-gray-activeTitle data-[state=closed]:border-b-transparent">
                        {title}
                    </AccordionTrigger>
                    <AccordionContent className="py-4">{content}</AccordionContent>
                </AccordionItem>
            </AccordionRoot>
        </div>);
};
